import React, { Component } from "react";
import {
  Route,
  NavLink,
  Redirect,
  HashRouter
} from 'react-router-dom';
import { render } from "react-dom";
import 'antd/dist/antd.css';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
//For Normal textual pin search
import SearchPin from './searchpin';
// For Random pin search
import RPS from "./rndmpnsrch";
//For Upload Image and Search
import UploadImageAndSearch from './uploadandsearch';
//import UserWeather from './getuserweather'; //-- Display user's weather
import { Button, notification, Layout, Row, Icon } from 'antd';

const { Header, Footer, Content } = Layout;

const headLine = {
  color: '#ffffff',
  textAlign: 'center',

}

const donationBtn =  {
  height: '40px',
  width: '40%',
  minWidth: '240px'
}

const close = () => {
  console.log('Notification was closed. Either the close button was clicked or duration time elapsed.');
};

const openNotification = () => {
  const key = `open${Date.now()}`;
  const btn = (
    <a href="https://www.instamojo.com/@designtack/" target="_blank" rel="noopener noreferrer"><Button type="primary" style={donationBtn} size="small" >
    {/*onClick={() => notification.close(key)}*/}
    <Icon type="coffee" /> Buy me a Coffee?
    </Button></a>
  );
  notification.open({
    message: 'Big thanks to..',
    description: 'Pinterest , Firebase, Designtack and People around me. More updates to this are coming soon! Till then..',
    btn,
    key,
    onClose: close,
  });
};


class Main extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Layout>
          <Header>
              <h1 style={headLine}><a href="#" target="_blank" rel="noopener noreferrer">What2Wear2Day</a></h1>
          </Header>

          <Content>
            <HashRouter>
    <div>
          <Redirect from="/" exact to="/searchpin" />
          <ul className="header">
            <li><NavLink  to='/uploadandsearch'>Image Search</NavLink></li>
            <li><NavLink exact to='/searchpin'>Get Inspired</NavLink></li>
            <li><NavLink  to='/rndmpnsrch'>Randomize</NavLink></li>
          </ul>
          <div className="content">
            <Route path='/uploadandsearch' component={UploadImageAndSearch}/>
            <Route exact path='/searchpin' component={SearchPin}/>  
            <Route path='/rndmpnsrch' component={RPS}/>  
          </div>
    </div>
            
          </HashRouter>
        </Content>

          <Footer>
            <Row type="flex" justify="center"> 
            <p>Made at <a href="http://www.designtack.com" target="_blank" rel="noopener noreferrer"><b>Designtack</b></a>. Thank you..</p><a onClick={openNotification}><Icon type="api" spin="true" /></a>
            </Row>
          </Footer>
        </Layout>
      </div>
    );
  }
}

render(<Main />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js